import React, { FC, Fragment, useEffect, useState } from "react";
import { useParams, useLocation } from 'react-router-dom';
import { Helmet } from "react-helmet-async";
import Pagination from "shared/Pagination/Pagination";
import { Dialog, Popover, Transition } from "@headlessui/react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonThird from "shared/Button/ButtonThird";
import ButtonClose from "shared/ButtonClose/ButtonClose";
import Checkbox from "shared/Checkbox/Checkbox";
import EmptyBox from "shared/EmptyBox/EmptyBox";
import Slider from "rc-slider";
import Radio from "shared/Radio/Radio";
import Input from "shared/Input/Input";
import ButtonCircle from "shared/Button/ButtonCircle";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import MySwitch from "components/MySwitch";


import SectionSliderCollections from "components/SectionSliderLargeProduct";
// import SectionPromo1 from "components/SectionPromo1";
import ProductCard from "components/ProductCard";
import TabFilters from "./TabFilters";
import { PRODUCTS } from "data/data";
import axios from 'axios';
import API_HOST from '../config/config';
import { useAuth } from '../contains/AuthContext';

export interface CategoryCollectionProps {
  className?: string;
}

// DEMO DATA
const DATA_categories = [
  {
    name: "New Arrivals",
  },
  {
    name: "Sale",
  },
  {
    name: "Backpacks",
  },
  {
    name: "Travel Bags",
  },
  {
    name: "Laptop Sleeves",
  },
  {
    name: "Organization",
  },
  {
    name: "Accessories",
  },
];

const DATA_colors = [
  { name: "White" },
  { name: "Beige" },
  { name: "Blue" },
  { name: "Black" },
  { name: "Brown" },
  { name: "Green" },
  { name: "Navy" },
];

const DATA_sizes = [
  { name: "XXS" },
  { name: "XS" },
  { name: "S" },
  { name: "M" },
  { name: "L" },
  { name: "XL" },
  { name: "2XL" },
];

const DATA_sortOrderRadios = [
  { name: "Price Hight - Low", id: "2" },
  { name: "Price Low - Hight", id: "3" },
  { name: "Number of Reviews", id: "4" },
  { name: "Newest", id: "5" },
  { name: "Alphabetical", id: "6" },
];

/*const DATA_sortOrderRadios = [
  { name: "Most Popular", id: "Most-Popular" },
  { name: "Best Rating", id: "Best-Rating" },
  { name: "Newest", id: "Newest" },
  { name: "Price Low - Hight", id: "Price-low-hight" },
  { name: "Price Hight - Low", id: "Price-hight-low" },
];*/

const PRICE_RANGE = [1, 5000];

const CategoryCollection: FC<CategoryCollectionProps> = ({ className = "" }) => {
  const { name, search } = useParams<{ name: string, search: string }>();
  const location = useLocation();

  const inputRef = React.createRef<HTMLInputElement>();
  const [isOpenMoreFilter, setisOpenMoreFilter] = useState(false);
  //
  const [isOnSale, setIsIsOnSale] = useState(true);
  const [rangePrices, setRangePrices] = useState([1, 5000]);
  const [categoriesState, setCategoriesState] = useState<string[]>([]);
  const [colorsState, setColorsState] = useState<string[]>([]);
  const [sizesState, setSizesState] = useState<string[]>([]);
  const [sortOrderStates, setSortOrderStates] = useState<string>("");
  const [searchValue, setSearchValue] = useState<string>(((search == undefined) ? '' : search))

  // category get
  const [headerCategory, setHeaderCategory] = useState<any[]>([]);

  const [productData, setProductData] = useState<any[]>([]);
  const [page, setPage] = useState<number>(1);
  const [isLoading, setIsLoading] = useState(false);
  const [loadMoreBtn, setLoadMoreBtn] = useState(false);
  const [pleaseWaitBtn, setPleaseWaitBtn] = useState(false);
  const [viewSearchDataNotFound, setviewSearchDataNotFound] = useState(true);
  const [dataNotFound, setDataNotFound] = useState(false);
  const [totalRecode, setTotalRecode] = useState(0);
  const { user } = useAuth();

  const fetchCategoryData = async () => {
    try {
      axios.post(API_HOST + '/api/get-category-list', {
        nopaginate: '1',
        status: '1',
        order: 'asc',
        _token: 'asdsasa',
      })
        .then(response => {
          if (response.data.success === 0) {
            setHeaderCategory(response.data.data.categories);
          }
        })
        .catch(error => {
          console.error('Error fetching data:', error);
        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const resetStateData = () => {
    setProductData([]);
    setIsLoading(false);
    setLoadMoreBtn(false);
    setTotalRecode(0);
    setDataNotFound(false);
  };

  useEffect(() => {
    setSearchValue(((search == undefined) ? '' : search));
    if (inputRef.current) {
      inputRef.current.value = ((search == undefined) ? '' : search);
    }
    fetchCategoryData();
    resetStateData();
    setPage(1);
  }, [name, search]);

  useEffect(() => { }, [searchValue]);

  useEffect(() => {
    if (page == 1) {
      setviewSearchDataNotFound(true);
      getApiCall();
    }
  }, [page]);

  useEffect(() => { }, [productData]);

  const getApiCall = async () => {
    fetchData();
  };

  const fetchFilterData = () => {
    resetStateData();
    setPage(1);
  };

  useEffect(() => { }, [categoriesState]);

  useEffect(() => { }, [sortOrderStates]);

  const fetchData = async () => {
    setIsLoading(true);
    if (page == 1) {
      setPleaseWaitBtn(false);
    }
    else {
      setPleaseWaitBtn(true);
    }
    setLoadMoreBtn(false);
    try {
      axios.post(API_HOST + '/api/get-product-list', {
        nopaginate: '0',
        page: `${page}`,
        per_page: '8',
        url: `${((name == undefined) ? '' : name)}`,
        query: `${((searchValue == undefined) ? '' : searchValue)}`,
        category: categoriesState.filter(item => item !== undefined && item !== null && item !== ''),
        sort_by: sortOrderStates,
        price_by: rangePrices,
        user_id: user ? user.id : '0'
      })
        .then(response => {
          if (response.data.success == 0) {
            if (typeof response.data.data.data !== 'undefined' && response.data.data.data !== null && Object.keys(response.data.data.data).length > 0) {
              setviewSearchDataNotFound(false);
              setProductData(prevProductData => [...prevProductData, ...response.data.data.data]);
              setPage(prevPage => (prevPage + 1));
              setTotalRecode(response.data.data.total);
              if (response.data.data.total == response.data.data.to) {
                setLoadMoreBtn(false);
              }
              else {
                setLoadMoreBtn(true);
              }
              setPleaseWaitBtn(false);
            }
            else {
              if (page == 1) {
                setviewSearchDataNotFound(false);
                setDataNotFound(true);
                setProductData([]);
              }
              setPage(prevPage => (prevPage + 1));
              setLoadMoreBtn(false);
              setPleaseWaitBtn(false);
            }
          }
        })
        .catch(error => {
          setPleaseWaitBtn(false);
        });
    } catch (error) {
      setPleaseWaitBtn(false);
    } finally {
      setIsLoading(false);
    }
  };

  //
  const closeModalMoreFilter = () => setisOpenMoreFilter(false);
  const openModalMoreFilter = () => setisOpenMoreFilter(true);

  //

  const handleChangeCategories = (checked: boolean, name: string) => {
    checked
      ? setCategoriesState([...categoriesState, name])
      : setCategoriesState(categoriesState.filter((i) => i !== name));
  };

  const handleChangeColors = (checked: boolean, name: string) => {
    checked
      ? setColorsState([...colorsState, name])
      : setColorsState(colorsState.filter((i) => i !== name));
  };

  const handleChangeSizes = (checked: boolean, name: string) => {
    checked
      ? setSizesState([...sizesState, name])
      : setSizesState(sizesState.filter((i) => i !== name));
  };



  //

  // OK
  const renderXClear = () => {
    return (
      <span className="flex-shrink-0 w-4 h-4 rounded-full bg-slate-500 text-white flex items-center justify-center ml-3 cursor-pointer">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-3 w-3"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      </span>
    );
  };

  // OK
  const renderTabsCategories = () => {
    return (
      <Popover className="relative">
        {({ open, close }) => (
          <>
            <Popover.Button
              className={`flex items-center justify-center px-4 py-2 text-sm rounded-full border focus:outline-none select-none
               ${open
                  ? "!border-primary-500 "
                  : "border-neutral-300 "
                }
                ${!!categoriesState.length
                  ? "!border-primary-500 bg-primary-50 text-primary-900"
                  : "border-neutral-300  text-neutral-700  hover:border-neutral-400"
                }
                `}
            >
              <svg
                className="w-4 h-4"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8 2V5"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M16 2V5"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M7 13H15"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M7 17H12"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M16 3.5C19.33 3.68 21 4.95 21 9.65V15.83C21 19.95 20 22.01 15 22.01H9C4 22.01 3 19.95 3 15.83V9.65C3 4.95 4.67 3.69 8 3.5H16Z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

              <span className="ml-2">Categories</span>
              {!categoriesState.length ? (
                <ChevronDownIcon className="w-4 h-4 ml-3" />
              ) : (
                <span onClick={() => { setCategoriesState([]); fetchFilterData(); }}>
                  {renderXClear()}
                </span>
              )}
            </Popover.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Popover.Panel className="absolute z-40 w-screen max-w-sm px-4 mt-3 left-0 sm:px-0 lg:max-w-md">
                <div className="overflow-hidden rounded-2xl shadow-xl bg-white border border-neutral-200 ">
                  <div className="relative flex flex-col px-5 py-6 space-y-5">
                    <Checkbox
                      name="All Categories"
                      label="All Categories"
                      defaultChecked={categoriesState.includes(
                        ""
                      )}
                      onChange={(checked) =>
                        handleChangeCategories(checked, "")
                      }
                    />
                    <div className="w-full border-b border-neutral-200" />
                    {headerCategory.length > 0 && (headerCategory.map((item, index) => (
                      <div key={item.name} className="">
                        <Checkbox className="capitalize"
                          name={item.name}
                          label={item.name}
                          defaultChecked={categoriesState.includes(item.id)}
                          onChange={(checked) =>
                            handleChangeCategories(checked, item.id)
                          }
                        />
                      </div>
                    )))}
                  </div>
                  <div className="p-5 bg-neutral-50 flex items-center justify-between">
                    <ButtonThird
                      onClick={() => {
                        close();
                        setCategoriesState([]);
                        fetchFilterData();
                      }}
                      sizeClass="px-4 py-2 sm:px-5"
                    >
                      Clear
                    </ButtonThird>
                    <ButtonPrimary
                      onClick={() => {
                        close();
                        fetchFilterData();
                      }}
                      sizeClass="px-4 py-2 sm:px-5"
                    >
                      Apply
                    </ButtonPrimary>
                  </div>
                </div>
              </Popover.Panel>
            </Transition>
          </>
        )}
      </Popover>
    );
  };

  // OK
  const renderTabsSortOrder = () => {
    return (
      <Popover className="relative">
        {({ open, close }) => (
          <>
            <Popover.Button
              className={`flex items-center justify-center px-4 py-2 text-sm border border-slate-300  text-slate-800  focus:outline-none select-none
              ${open ? "!border-slate-300 " : ""}
                ${!!sortOrderStates.length
                  ? "!border-primary-500 bg-primary-50 text-primary-900"
                  : "border-neutral-300  text-neutral-700  hover:border-neutral-400 "
                }
                `}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="currentColor" viewBox="0 0 16 16" className="bi bi-currency-rupee"><path d="M4 3.06h2.726c1.22 0 2.12.575 2.325 1.724H4v1.051h5.051C8.855 7.001 8 7.558 6.788 7.558H4v1.317L8.437 14h2.11L6.095 8.884h.855c2.316-.018 3.465-1.476 3.688-3.049H12V4.784h-1.345c-.08-.778-.357-1.335-.793-1.732H12V2H4z"></path></svg>

              <span className="ml-2">
                {sortOrderStates
                  ? DATA_sortOrderRadios.filter(
                    (i) => i.id === sortOrderStates
                  )[0].name
                  : "Sort order"}
              </span>
              {!sortOrderStates.length ? (
                <ChevronDownIcon className="w-4 h-4 ml-3" />
              ) : (
                <span onClick={() => { setSortOrderStates(""); fetchFilterData(); }}>
                  {renderXClear()}
                </span>
              )}
            </Popover.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Popover.Panel className="absolute z-40 w-screen max-w-sm px-4 mt-3 right-0 sm:px-0 lg:max-w-sm">
                <div className="overflow-hidden rounded-0 shadow-xl bg-white  border border-neutral-200 ">
                  <div className="relative flex flex-col px-5 py-6 space-y-3">
                    {DATA_sortOrderRadios.map((item) => (
                      <Radio
                        id={item.id}
                        key={item.id}
                        name="radioNameSort"
                        label={item.name}
                        defaultChecked={sortOrderStates === item.id}
                        onChange={setSortOrderStates}
                      />
                    ))}
                  </div>
                  <div className="p-5 bg-neutral-50 flex items-center justify-between">
                    <ButtonThird
                      onClick={() => {
                        close();
                        setSortOrderStates("");
                        fetchFilterData();
                      }}
                      sizeClass="px-4 py-2 sm:px-5"
                    >
                      Clear
                    </ButtonThird>
                    <ButtonPrimary
                      onClick={() => {
                        close();
                        fetchFilterData();
                      }}
                      sizeClass="px-4 py-2 sm:px-5"
                    >
                      Apply
                    </ButtonPrimary>
                  </div>
                </div>
              </Popover.Panel>
            </Transition>
          </>
        )}
      </Popover>
    );
  };

  // OK
  const renderTabsColor = () => {
    return (
      <Popover className="relative">
        {({ open, close }) => (
          <>
            <Popover.Button
              className={`flex items-center justify-center px-4 py-2 text-sm rounded-full border focus:outline-none select-none
              ${open ? "!border-primary-500 " : ""}
                ${!!colorsState.length
                  ? "!border-primary-500 bg-primary-50 text-primary-900"
                  : "border-neutral-300 text-neutral-700 hover:border-neutral-400"
                }
                `}
            >
              <svg
                className="w-4 h-4"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.01 18.0001L3 13.9901C1.66 12.6501 1.66 11.32 3 9.98004L9.68 3.30005L17.03 10.6501C17.4 11.0201 17.4 11.6201 17.03 11.9901L11.01 18.0101C9.69 19.3301 8.35 19.3301 7.01 18.0001Z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M8.35 1.94995L9.69 3.28992"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M2.07 11.92L17.19 11.26"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M3 22H16"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M18.85 15C18.85 15 17 17.01 17 18.24C17 19.26 17.83 20.09 18.85 20.09C19.87 20.09 20.7 19.26 20.7 18.24C20.7 17.01 18.85 15 18.85 15Z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

              <span className="ml-2">Colors</span>
              {!colorsState.length ? (
                <ChevronDownIcon className="w-4 h-4 ml-3" />
              ) : (
                <span onClick={() => setColorsState([])}>{renderXClear()}</span>
              )}
            </Popover.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Popover.Panel className="absolute z-40 w-screen max-w-sm px-4 mt-3 left-0 sm:px-0 lg:max-w-sm">
                <div className="overflow-hidden rounded-2xl shadow-xl bg-white border border-neutral-200 ">
                  <div className="relative flex flex-col px-5 py-6 space-y-5">
                    {DATA_colors.map((item) => (
                      <div key={item.name} className="">
                        <Checkbox
                          name={item.name}
                          label={item.name}
                          defaultChecked={colorsState.includes(item.name)}
                          onChange={(checked) =>
                            handleChangeColors(checked, item.name)
                          }
                        />
                      </div>
                    ))}
                  </div>
                  <div className="p-5 bg-slate-50 flex items-center justify-between">
                    <ButtonThird
                      onClick={() => {
                        close();
                        setColorsState([]);
                      }}
                      sizeClass="px-4 py-2 sm:px-5"
                    >
                      Clear
                    </ButtonThird>
                    <ButtonPrimary
                      onClick={close}
                      sizeClass="px-4 py-2 sm:px-5"
                    >
                      Apply
                    </ButtonPrimary>
                  </div>
                </div>
              </Popover.Panel>
            </Transition>
          </>
        )}
      </Popover>
    );
  };

  // OK
  const renderTabsSize = () => {
    return (
      <Popover className="relative">
        {({ open, close }) => (
          <>
            <Popover.Button
              className={`flex items-center justify-center px-4 py-2 text-sm rounded-full border focus:outline-none select-none
              ${open ? "!border-primary-500 " : ""}
                ${!!sizesState.length
                  ? "!border-primary-500 bg-primary-50 text-primary-900"
                  : "border-neutral-300  text-neutral-700 hover:border-neutral-400 "
                }
                `}
            >
              <svg
                className="w-4 h-4"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21 9V3H15"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M3 15V21H9"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M21 3L13.5 10.5"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M10.5 13.5L3 21"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

              <span className="ml-2">Sizes</span>
              {!sizesState.length ? (
                <ChevronDownIcon className="w-4 h-4 ml-3" />
              ) : (
                <span onClick={() => setSizesState([])}>{renderXClear()}</span>
              )}
            </Popover.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Popover.Panel className="absolute z-40 w-screen max-w-sm px-4 mt-3 left-0 sm:px-0 lg:max-w-sm">
                <div className="overflow-hidden rounded-0 border border-slate-300 bg-white ">
                  <div className="relative flex flex-col px-5 py-6 space-y-5">
                    {DATA_sizes.map((item) => (
                      <div key={item.name} className="">
                        <Checkbox
                          name={item.name}
                          label={item.name}
                          defaultChecked={sizesState.includes(item.name)}
                          onChange={(checked) =>
                            handleChangeSizes(checked, item.name)
                          }
                        />
                      </div>
                    ))}
                  </div>
                  <div className="p-5 bg-slate-50 flex items-center justify-between">
                    <ButtonThird
                      onClick={() => {
                        close();
                        setSizesState([]);
                      }}
                      sizeClass="px-4 py-2 sm:px-5 "
                    >
                      Clear
                    </ButtonThird>
                    <ButtonPrimary
                      onClick={close}
                      sizeClass="px-4 py-2 sm:px-5"
                    >
                      Apply
                    </ButtonPrimary>
                  </div>
                </div>
              </Popover.Panel>
            </Transition>
          </>
        )}
      </Popover>
    );
  };

  // OK
  const renderTabsPriceRage = () => {
    return (
      <Popover className="relative">
        {({ open, close }) => (
          <>
            <Popover.Button
              className={`flex items-center justify-center px-4 py-2 text-sm rounded-0 border border-slate-300 text-slate-800 focus:outline-none `}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="currentColor" className="bi bi-currency-rupee" viewBox="0 0 16 16">
                <path d="M4 3.06h2.726c1.22 0 2.12.575 2.325 1.724H4v1.051h5.051C8.855 7.001 8 7.558 6.788 7.558H4v1.317L8.437 14h2.11L6.095 8.884h.855c2.316-.018 3.465-1.476 3.688-3.049H12V4.784h-1.345c-.08-.778-.357-1.335-.793-1.732H12V2H4z" />
              </svg>

              <span className="ml-1 min-w-[90px]">{`${rangePrices[0]} RS - ${rangePrices[1]} RS`}</span>
              {rangePrices[0] === PRICE_RANGE[0] &&
                rangePrices[1] === PRICE_RANGE[1] ? null : (
                <span onClick={() => { setRangePrices(PRICE_RANGE); fetchFilterData(); }}>
                  {renderXClear()}
                </span>
              )}
            </Popover.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Popover.Panel className="absolute z-40 w-screen max-w-sm px-4 mt-3 left-0 sm:px-0 ">
                <div className="overflow-hidden rounded-0 shadow-xl bg-white  border border-neutral-200">
                  <div className="relative flex flex-col px-5 py-6 space-y-8">
                    <div className="space-y-5">
                      <span className="font-medium">Price range</span>
                      <Slider
                        range
                        min={PRICE_RANGE[0]}
                        max={PRICE_RANGE[1]}
                        step={1}
                        defaultValue={[rangePrices[0], rangePrices[1]]}
                        allowCross={false}
                        onChange={(_input: number | number[]) =>
                          setRangePrices(_input as number[])
                        }
                      />
                    </div>

                    <div className="flex justify-between space-x-5">
                      <div>
                        <label
                          htmlFor="minPrice"
                          className="block text-sm font-medium text-neutral-700"
                        >
                          Min price
                        </label>
                        <div className="mt-1 relative rounded-md">
                          <span className="absolute inset-y-0 right-4 flex items-center pointer-events-none text-neutral-500 sm:text-sm font-sans">
                            ₹
                          </span>
                          <input
                            type="text"
                            name="minPrice"
                            disabled
                            id="minPrice"
                            className="block w-32 pr-10 pl-4 sm:text-sm border-neutral-200 rounded-0 bg-transparent"
                            value={rangePrices[0]}
                          />
                        </div>
                      </div>
                      <div>
                        <label
                          htmlFor="maxPrice"
                          className="block text-sm font-medium text-neutral-700 "
                        >
                          Max price
                        </label>
                        <div className="mt-1 relative rounded-md">
                          <span className="absolute inset-y-0 right-4 flex items-center pointer-events-none text-neutral-500 sm:text-sm font-sans">
                            ₹
                          </span>
                          <input
                            type="text"
                            disabled
                            name="maxPrice"
                            id="maxPrice"
                            className="block w-32 pr-10 pl-4 sm:text-sm border-neutral-200  rounded-0 bg-transparent"
                            value={rangePrices[1]}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="p-5 bg-neutral-50 flex items-center justify-between">
                    <ButtonThird
                      onClick={() => {
                        setRangePrices(PRICE_RANGE);
                        close();
                        fetchFilterData();
                      }}
                      sizeClass="px-4 py-2 sm:px-5"
                    >
                      Clear
                    </ButtonThird>
                    <ButtonPrimary
                      onClick={() => {
                        close();
                        fetchFilterData();
                      }}
                      sizeClass="px-4 py-2 sm:px-5"
                    >
                      Apply
                    </ButtonPrimary>
                  </div>
                </div>
              </Popover.Panel>
            </Transition>
          </>
        )}
      </Popover>
    );
  };

  // OK
  const renderTabIsOnsale = () => {
    return (
      <div
        className={`flex items-center justify-center px-4 py-2 text-sm rounded-full border focus:outline-none cursor-pointer select-none ${isOnSale
          ? "border-primary-500 bg-primary-50 text-primary-900"
          : "border-neutral-300 text-neutral-700 hover:border-neutral-400"
          }`}
        onClick={() => setIsIsOnSale(!isOnSale)}
      >
        <svg
          className="w-4 h-4"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.9889 14.6604L2.46891 13.1404C1.84891 12.5204 1.84891 11.5004 2.46891 10.8804L3.9889 9.36039C4.2489 9.10039 4.4589 8.59038 4.4589 8.23038V6.08036C4.4589 5.20036 5.1789 4.48038 6.0589 4.48038H8.2089C8.5689 4.48038 9.0789 4.27041 9.3389 4.01041L10.8589 2.49039C11.4789 1.87039 12.4989 1.87039 13.1189 2.49039L14.6389 4.01041C14.8989 4.27041 15.4089 4.48038 15.7689 4.48038H17.9189C18.7989 4.48038 19.5189 5.20036 19.5189 6.08036V8.23038C19.5189 8.59038 19.7289 9.10039 19.9889 9.36039L21.5089 10.8804C22.1289 11.5004 22.1289 12.5204 21.5089 13.1404L19.9889 14.6604C19.7289 14.9204 19.5189 15.4304 19.5189 15.7904V17.9403C19.5189 18.8203 18.7989 19.5404 17.9189 19.5404H15.7689C15.4089 19.5404 14.8989 19.7504 14.6389 20.0104L13.1189 21.5304C12.4989 22.1504 11.4789 22.1504 10.8589 21.5304L9.3389 20.0104C9.0789 19.7504 8.5689 19.5404 8.2089 19.5404H6.0589C5.1789 19.5404 4.4589 18.8203 4.4589 17.9403V15.7904C4.4589 15.4204 4.2489 14.9104 3.9889 14.6604Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9 15L15 9"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.4945 14.5H14.5035"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.49451 9.5H9.50349"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>

        <span className="line-clamp-1 ml-2">On sale</span>
        {isOnSale && renderXClear()}
      </div>
    );
  };

  // OK
  const renderMoreFilterItem = (
    data: {
      name: string;
      description?: string;
      defaultChecked?: boolean;
    }[]
  ) => {
    const list1 = data.filter((_, i) => i < data.length / 2);
    const list2 = data.filter((_, i) => i >= data.length / 2);
    return (
      <div className="grid grid-cols-2 gap-x-4 sm:gap-x-8 gap-8">
        <div className="flex flex-col space-y-5">
          {list1.map((item) => (
            <Checkbox
              key={item.name}
              name={item.name}
              subLabel={item.description}
              label={item.name}
              defaultChecked={!!item.defaultChecked}
              sizeClassName="w-5 h-5 sm:w-6 sm:h-6"
            />
          ))}
        </div>
        <div className="flex flex-col space-y-5">
          {list2.map((item) => (
            <Checkbox
              key={item.name}
              name={item.name}
              subLabel={item.description}
              label={item.name}
              defaultChecked={!!item.defaultChecked}
              sizeClassName="w-5 h-5 sm:w-6 sm:h-6"
            />
          ))}
        </div>
      </div>
    );
  };

  // FOR RESPONSIVE MOBILE
  const renderTabMobileFilter = () => {
    return (
      <div className="flex-shrink-0">
        <div
          className={`flex flex-shrink-0 items-center justify-center px-4 py-2 text-sm border border-slate-300  text-slate-800 focus:outline-none text-primary-900 focus:outline-none cursor-pointer select-none`}
          onClick={openModalMoreFilter}
        >
          <svg
            className="w-4 h-4"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M22 6.5H16"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M6 6.5H2"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10 10C11.933 10 13.5 8.433 13.5 6.5C13.5 4.567 11.933 3 10 3C8.067 3 6.5 4.567 6.5 6.5C6.5 8.433 8.067 10 10 10Z"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M22 17.5H18"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8 17.5H2"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M14 21C15.933 21 17.5 19.433 17.5 17.5C17.5 15.567 15.933 14 14 14C12.067 14 10.5 15.567 10.5 17.5C10.5 19.433 12.067 21 14 21Z"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>

          <span className="ml-2">Products filters</span>
          <span onClick={() => { fetchFilterData(); }}>
            {renderXClear()}
          </span>
        </div>

        <Transition appear show={isOpenMoreFilter} as={Fragment}>
          <Dialog
            as="div"
            className="fixed inset-0 z-50 overflow-y-auto"
            onClose={closeModalMoreFilter}
          >
            <div className="min-h-screen text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-40" />
              </Transition.Child>

              {/* This element is to trick the browser into centering the modal contents. */}
              <span
                className="inline-block h-screen align-middle"
                aria-hidden="true"
              >
                &#8203;
              </span>
              <Transition.Child
                className="inline-block h-screen w-full max-w-4xl"
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <div className="inline-flex flex-col w-full text-left align-middle transition-all transform bg-white h-full">
                  <div className="relative flex-shrink-0 px-6 py-4 border-b border-neutral-200 text-center">
                    <Dialog.Title
                      as="h3"
                      className="text-lg font-medium leading-6 text-gray-900"
                    >
                      Products filters
                    </Dialog.Title>
                    <span className="absolute left-3 top-3">
                      <ButtonClose onClick={closeModalMoreFilter} />
                    </span>
                  </div>

                  <div className="flex-grow overflow-y-auto">
                    <div className="px-6 sm:px-8 md:px-10 divide-y divide-neutral-200">
                      {/* --------- */}
                      {/* ---- */}
                      <div className="py-7">
                        <h3 className="text-xl font-medium">Categories</h3>
                        <div className="mt-6 relative ">
                          {renderMoreFilterItem(headerCategory)}
                        </div>
                      </div>
                      {/* --------- */}
                      {/* ---- */}
                      {/*<div className="py-7">
                        <h3 className="text-xl font-medium">Colors</h3>
                        <div className="mt-6 relative ">
                          {renderMoreFilterItem(DATA_colors)}
                        </div>
                      </div>*/}
                      {/* --------- */}
                      {/* ---- */}
                      {/*<div className="py-7">
                        <h3 className="text-xl font-medium">Size</h3>
                        <div className="mt-6 relative ">
                          {renderMoreFilterItem(DATA_sizes)}
                        </div>
                      </div>*/}

                      {/* --------- */}
                      {/* ---- */}
                      <div className="py-7">
                        <h3 className="text-xl font-medium">Range Prices</h3>
                        <div className="mt-6 relative ">
                          <div className="relative flex flex-col space-y-8">
                            <div className="space-y-5">
                              <Slider
                                range
                                className="text-red-400"
                                min={PRICE_RANGE[0]}
                                max={PRICE_RANGE[1]}
                                defaultValue={rangePrices}
                                allowCross={false}
                                onChange={(_input: number | number[]) =>
                                  setRangePrices(_input as number[])
                                }
                              />
                            </div>

                            <div className="flex justify-between space-x-5">
                              <div>
                                <label
                                  htmlFor="minPrice"
                                  className="block text-sm font-medium text-neutral-700"
                                >
                                  Min price
                                </label>
                                <div className="mt-1 relative rounded-md">
                                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                    <span className="text-neutral-500 sm:text-sm font-sans">
                                      ₹
                                    </span>
                                  </div>
                                  <input
                                    type="text"
                                    name="minPrice"
                                    disabled
                                    id="minPrice"
                                    className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-8 pr-3 sm:text-sm border-neutral-200 rounded-0 text-neutral-900"
                                    value={rangePrices[0]}
                                  />
                                </div>
                              </div>
                              <div>
                                <label
                                  htmlFor="maxPrice"
                                  className="block text-sm font-medium text-neutral-700"
                                >
                                  Max price
                                </label>
                                <div className="mt-1 relative rounded-md">
                                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                    <span className="text-neutral-500 sm:text-sm  font-sans">
                                      ₹
                                    </span>
                                  </div>
                                  <input
                                    type="text"
                                    disabled
                                    name="maxPrice"
                                    id="maxPrice"
                                    className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-8 pr-3 sm:text-sm border-neutral-200 rounded-0 text-neutral-900"
                                    value={rangePrices[1]}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* --------- */}
                      {/* ---- */}
                      <div className="py-7">
                        <h3 className="text-xl font-medium">Sort Order</h3>
                        <div className="mt-6 relative ">
                          <div className="relative flex flex-col space-y-5">
                            {DATA_sortOrderRadios.map((item) => (
                              <Radio
                                id={item.id}
                                key={item.id}
                                name="radioNameSort"
                                label={item.name}
                                defaultChecked={sortOrderStates === item.id}
                                onChange={setSortOrderStates}
                              />
                            ))}
                          </div>
                        </div>
                      </div>

                      {/* --------- */}
                      {/* ---- */}
                      {/*<div className="py-7">
                        <h3 className="text-xl font-medium">On sale!</h3>
                        <div className="mt-6 relative ">
                          <MySwitch
                            label="On sale!"
                            desc="Products currently on sale"
                            enabled={isOnSale}
                            onChange={setIsIsOnSale}
                          />
                        </div>
                      </div>*/}
                    </div>
                  </div>

                  <div className="p-6 flex-shrink-0 bg-neutral-50 flex items-center justify-between">
                    <ButtonThird
                      onClick={() => {
                        setRangePrices(PRICE_RANGE);
                        setCategoriesState([]);
                        setColorsState([]);
                        setSortOrderStates("");
                        closeModalMoreFilter();
                        fetchFilterData();
                      }}
                      sizeClass="py-2.5 px-5"
                    >
                      Clear
                    </ButtonThird>
                    <ButtonPrimary
                      onClick={() => {
                        closeModalMoreFilter();
                        fetchFilterData();
                      }}
                      sizeClass="py-2.5 px-5"
                    >
                      Apply
                    </ButtonPrimary>
                  </div>
                </div>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition>
      </div>
    );
  };

  const handleSearchSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSearchValue((inputRef.current ? inputRef.current.value : ''));
    resetStateData();
    setPage(1);
  };

  return (
    <div
      className={`nc-PageCollection ${className}`}
      data-nc-id="PageCollection"
    >
      <Helmet>
        <title>{(name ? ((name.charAt(0).toUpperCase() + name.slice(1)).replaceAll('-', " ") + ' || ') : '')} {(search ? ((search.charAt(0).toUpperCase() + search.slice(1)).replaceAll('-', " ") + ' || ') : '')} {(name == undefined && search == undefined) ? 'All Products || ' : ''}glamgenesis</title>
        <meta property="og:site_name" content="glamgenesis" />
        <meta property="og:type" content="website" />
        <meta property="og:description" content='Welcome to Tikasaheb, your premier destination for exquisite bath bombs and salts. Immerse yourself in luxury with our handcrafted products, proudly made in the heart of India and delivered to the UAE. Elevate your bathing experience with our meticulously crafted blends, designed to pamper and rejuvenate. Experience the essence of tradition and quality as we bring the artistry of Indian craftsmanship to your self-care routine. Indulge in the beauty of handmade excellence with Tikasaheb.' />
        <meta property="og:title" content={`${(name ? ((name.charAt(0).toUpperCase() + name.slice(1)).replaceAll('-', " ") + ' || ') : '')} ${(search ? ((search.charAt(0).toUpperCase() + search.slice(1)).replaceAll('-', " ") + ' || ') : '')} ${(name == undefined && search == undefined) ? 'All Products || ' : ''}glamgenesis`} />
        <meta property="og:image" itemProp="image" content="https://backend.thebodybucket.ae/backend/img/logo/logo.png" />
        <meta property="og:image:url" content="https://backend.thebodybucket.ae/backend/img/logo/logo.png" />
        <meta property="og:image:secure_url" content="https://backend.thebodybucket.ae/backend/img/logo/logo.png" />
        <meta property="og:url" content={window.location.origin} />
      </Helmet>

      {
        (location.pathname.indexOf('search') > -1) && (
          <div>
            <div
              className={`nc-HeadBackgroundCommon h-24 2xl:h-28 top-0 left-0 right-0 w-full bg-primary-50 `}
              data-nc-id="HeadBackgroundCommon"
            />
            <div className="container">
              <header className="max-w-2xl mx-auto -mt-10 flex flex-col lg:-mt-7">
                <form
                  className="relative w-full"
                  onSubmit={handleSearchSubmit}
                >
                  <label
                    htmlFor="search-input"
                    className="text-neutral-500"
                  >
                    <span className="sr-only">Search all icons</span>
                    <Input
                      ref={inputRef}
                      defaultValue={searchValue}
                      className="shadow-lg border-0"
                      id="search-input"
                      type="search"
                      placeholder="Type your keywords"
                      sizeClass="pl-14 py-5 pr-5 md:pl-16"
                      rounded="rounded-full"
                    />
                    <ButtonCircle
                      className="absolute right-2.5 top-1/2 transform -translate-y-1/2"
                      size=" w-11 h-11"
                      type="submit"
                    >
                      <i className="las la-arrow-right text-xl"></i>
                    </ButtonCircle>
                    <span className="absolute left-5 top-1/2 transform -translate-y-1/2 text-2xl md:left-6">
                      <svg
                        className="h-5 w-5"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.5 21C16.7467 21 21 16.7467 21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21Z"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M22 22L20 20"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                  </label>
                </form>
              </header>
            </div>
          </div>
        )}

      <div className="container py-6 lg:pb-6 lg:pt-6  mb-10 mt-10  lg:mt-10 lg:mb-10">
        <div className="space-y-10 lg:space-y-14x">
          {/* HEADING */}
          <div className="max-w-screen">
            <h2 className="text-custom-pink block text-2xl sm:text-3xl lg:text-4xl font-semibold capitalize">
              {((name == undefined) ? '' : (name ? ((name.charAt(0).toUpperCase() + name.slice(1))).replaceAll('-', " ") : ''))} {((searchValue == undefined || searchValue == '') ? '' : `Results for "${(searchValue != '' ? ((searchValue.charAt(0).toUpperCase() + searchValue.slice(1))).replaceAll('-', " ") : '')}"`)} {(name == undefined && (searchValue == undefined || searchValue == '')) ? 'All Products' : ''}
            </h2>
            {/* { totalRecode > 0 ? (<span className="block mt-4 text-neutral-500 text-sm sm:text-base">
              "{totalRecode} results"
            </span>) : '' } */}
          </div>

          <hr className="border-slate-200" />
          <main>
            {/* TABS FILTER */}
            {/*<TabFilters />*/}
            {/* <div className="flex lg:space-x-4"> */}
            {/* FOR DESKTOP */}
            <div className="hidden lg:flex flex-1 space-x-4">
              {renderTabsPriceRage()}
              {/* {renderTabsCategories()}  */}
              {/* {renderTabsColor()} */}
              {/* {renderTabsSize()} */}
              {/* {renderTabIsOnsale()} */}
              <div className="!ml-auto">{renderTabsSortOrder()}</div>
            </div>

            {/* FOR RESPONSIVE MOBILE */}
            <div className="flex overflow-x-auto lg:hidden space-x-4">
              {renderTabMobileFilter()}
            </div>
            {/* </div> */}
            {/* LOOP ITEMS */}
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-x-2 gap-y-2 sm:gap-y-2 sm:gap-x-2 lg:gap-x-3 lg:gap-y-3 xl:gap-y-3  xl:gap-x-3   mt-8 lg:mt-10">
              {typeof productData !== 'undefined' && productData !== null && (productData.length > 0 && (productData.map((item, index) => (
                <ProductCard data={item} key={index} />
              ))))}
              {PRODUCTS.map((item, index) => (
                <ProductCard data={item} key={index} />
              ))}
            </div>

            {/* --- skeletant-design --- */}
            {productData.length == 0 && page == 1 &&
              <div className="skeletant-target">
                {/* <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-2 gap-y-2 sm:gap-x-8 sm:gap-y-10 mt-8 lg:mt-10"> */}
                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-x-3 gap-y-3 sm:gap-x-4 sm:gap-y-4 mt-8 lg:mt-10">

                  <div className="">
                    <div className="skeletant-design h-[376px]"></div>
                    <div className="skeletant-design ld-no-img h-[24px] mt-4"></div>
                    <div className="skeletant-design ld-no-img h-[12px] mt-2"></div>
                    <div className="flex">
                      <div className="skeletant-design ld-no-img h-[30px] w-[100px] mt-2 mr-1"></div>
                      <div className="skeletant-design ld-no-img h-[30px] w-[50px] mt-2"></div>
                    </div>
                  </div>

                  <div className="">
                    <div className="skeletant-design h-[376px]"></div>
                    <div className="skeletant-design ld-no-img h-[24px] mt-4"></div>
                    <div className="skeletant-design ld-no-img h-[12px] mt-2"></div>
                    <div className="flex">
                      <div className="skeletant-design ld-no-img h-[30px] w-[100px] mt-2 mr-1"></div>
                      <div className="skeletant-design ld-no-img h-[30px] w-[50px] mt-2"></div>
                    </div>
                  </div>

                  <div className="">
                    <div className="skeletant-design h-[376px]"></div>
                    <div className="skeletant-design ld-no-img h-[24px] mt-4"></div>
                    <div className="skeletant-design ld-no-img h-[12px] mt-2"></div>
                    <div className="flex">
                      <div className="skeletant-design ld-no-img h-[30px] w-[100px] mt-2 mr-1"></div>
                      <div className="skeletant-design ld-no-img h-[30px] w-[50px] mt-2"></div>
                    </div>
                  </div>

                  <div className="">
                    <div className="skeletant-design h-[376px]"></div>
                    <div className="skeletant-design ld-no-img h-[24px] mt-4"></div>
                    <div className="skeletant-design ld-no-img h-[12px] mt-2"></div>
                    <div className="flex">
                      <div className="skeletant-design ld-no-img h-[30px] w-[100px] mt-2 mr-1"></div>
                      <div className="skeletant-design ld-no-img h-[30px] w-[50px] mt-2"></div>
                    </div>
                  </div>

                  <div className="">
                    <div className="skeletant-design h-[376px]"></div>
                    <div className="skeletant-design ld-no-img h-[24px] mt-4"></div>
                    <div className="skeletant-design ld-no-img h-[12px] mt-2"></div>
                    <div className="flex">
                      <div className="skeletant-design ld-no-img h-[30px] w-[100px] mt-2 mr-1"></div>
                      <div className="skeletant-design ld-no-img h-[30px] w-[50px] mt-2"></div>
                    </div>
                  </div>

                  <div className="">
                    <div className="skeletant-design h-[376px]"></div>
                    <div className="skeletant-design ld-no-img h-[24px] mt-4"></div>
                    <div className="skeletant-design ld-no-img h-[12px] mt-2"></div>
                    <div className="flex">
                      <div className="skeletant-design ld-no-img h-[30px] w-[100px] mt-2 mr-1"></div>
                      <div className="skeletant-design ld-no-img h-[30px] w-[50px] mt-2"></div>
                    </div>
                  </div>

                  <div className="">
                    <div className="skeletant-design h-[376px]"></div>
                    <div className="skeletant-design ld-no-img h-[24px] mt-4"></div>
                    <div className="skeletant-design ld-no-img h-[12px] mt-2"></div>
                    <div className="flex">
                      <div className="skeletant-design ld-no-img h-[30px] w-[100px] mt-2 mr-1"></div>
                      <div className="skeletant-design ld-no-img h-[30px] w-[50px] mt-2"></div>
                    </div>
                  </div>

                  <div className="">
                    <div className="skeletant-design h-[376px]"></div>
                    <div className="skeletant-design ld-no-img h-[24px] mt-4"></div>
                    <div className="skeletant-design ld-no-img h-[12px] mt-2"></div>
                    <div className="flex">
                      <div className="skeletant-design ld-no-img h-[30px] w-[100px] mt-2 mr-1"></div>
                      <div className="skeletant-design ld-no-img h-[30px] w-[50px] mt-2"></div>
                    </div>
                  </div>

                </div>
              </div>
            }
            {/* --- skeletant-design --- */}



            <EmptyBox show={dataNotFound ? '' : 'hidden'} />

            {/* PAGINATION */}
            <div className="flex flex-col mt-8 sm:mt-8 md:mt-8 lg:mt-10 xl:mt-16 space-y-5 sm:space-y-0 sm:space-x-3 sm:flex-row sm:justify-center sm:items-center">
              {/*<Pagination />*/}

              <ButtonPrimary className={`${pleaseWaitBtn ? '' : 'hidden'}`} loading >Loading...</ButtonPrimary>
              <ButtonPrimary className={`${loadMoreBtn ? '' : 'hidden'}`} onClick={() => fetchData()} disabled={isLoading} >Load More...</ButtonPrimary>
              {/*<ButtonPrimary loading>Show me more</ButtonPrimary>*/}
            </div>
          </main>
        </div>

        {/* === SECTION 5 === */}
        {/* <hr className="border-slate-200" />

        <SectionSliderCollections /> */}
        {/* <hr className="border-slate-200" /> */}

        {/* SUBCRIBES */}
        {/* <SectionPromo1 /> */}
      </div>
    </div>
  );
};

export default CategoryCollection;
